import { Component, OnInit, NgZone, ViewChild, Input } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  AbstractControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-perpetual-add',
  templateUrl: './perpetual-add.component.html',
  styleUrls: ['./perpetual-add.component.css'],
})
export class PerpetualAddComponent implements OnInit {
  form: FormGroup;
  imagePath: any;
  submitted = false;
  closeResult = '';
  showSpinner: Boolean = true;
  spinnerType = SPINNER.circle;
  description: any;
  galleryArr = [];
  isCreate = false;
  selectedItem;
  eventImage;
  item;
  user: any;
  userData: any;
  SubscriptionPlan: any;
  terms: string;
  kingdomPartnerStatus: any = null;
  btnText: string = 'Click to add discount';
  // @Input() firstSingup: any;
  constructor(
    private ngxService: NgxUiLoaderService,
    public router: Router,
    private modalService: NgbModal,
    private zone: NgZone,
    public fb: FormBuilder,
    public authenticationService: AuthenticationService
  ) {
    this.authenticationService.SharingData.subscribe((res: any) => {
      this.eventImage = res;
    });
  }
  ngOnInit() {
    this.getUserProfile();
    //this.description = localStorage.getItem('description') || '';
    let des = localStorage.getItem('description') || '';
    if (des && des != '') {
      this.btnText = 'Click to edit discount';
      this.description = des.replace(/[#*]/g, '');
    }
    let terms = localStorage.getItem('terms') || '';
    if (terms && terms != '') {
      this.terms = terms;
    }

    this.galleryAndPhotoGallery();
    // this.gallery();
    // this.photoGallery();
    this.imagePath = '';
    this.getPerpetual();
    this.form = this.fb.group({
      description: [this.description, []],
    });
  }

  // onFileSelect(event) {
  //   if (event.target.files.length > 0) {
  //     const file = event.target.files[0];
  //     console.log(file.name)
  //     const formData = new FormData();
  //     console.log(formData, 'testing')
  //     formData.append('image', file, file.name);
  //     formData.append('imageType', 'image');
  //     this.ngxService.start();
  //     this.authenticationService
  //       .upload(formData)
  //       .subscribe(
  //         data => {
  //           this.ngxService.stop();
  //           this.imagePath = environment.basePath + data['data'].url;
  //           console.log(this.imagePath, 'testing');
  //         },
  //         error => {
  //           this.ngxService.stop();
  //           if (error.status == 401) {

  //           } else {
  //             this.ngxService.stop();
  //             Swal.fire(
  //               "Error",
  //               "Oops...",
  //               error.error.message
  //             );
  //           }
  //         }
  //       );
  //   } else {
  //     Swal.fire(
  //       "Error",
  //       "Oops..."
  //     );
  //   }
  // }

  onSubmit(result): void {
    this.submitted = true;
    if (!this.eventImage) {
      Swal.fire('X', 'Image is required');
      return;
    }
    if (!this.form?.value?.description) {
      Swal.fire('X', 'Discount is required');
      return;
    }
    if (this.form.invalid) {
      return;
    }

    const termsAccepted = localStorage.getItem('termsAccepted') === 'true';
    const ravelPointsRequired = Number(localStorage.getItem('ravelPointsRequired')) || 0;

    this.authenticationService
      .perpetualAdd({
        imagePath: this.eventImage,
        description: result.description,
        terms: this.terms || '',
        termsAccepted: termsAccepted,
        ravelPointsRequired: ravelPointsRequired,
      })
      .subscribe(
        (response: any) => {
          this.submitted = false;
          this.isCreate = false;
          localStorage.removeItem('description');
          localStorage.removeItem('termsAccepted');
          localStorage.removeItem('ravelPointsRequired');
          this.getPerpetual();
          Swal.fire('', 'Member Discount created successfully', 'success');
        },
        (error) => {
          this.submitted = false;
          if (error) {
            Swal.fire('Error', error.error.message, 'error');
          }
        }
      );
  }

  getUserProfile() {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        this.userData = response.data;
        this.kingdomPartnerStatus = response.data?.kingdom_partner_status;
        this.getSubscriptionPlan(response.data?.subscriptionPlanType);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  public getPerpetual(): void {
    this.authenticationService.getPerpetualAdd().subscribe(
      (response: any) => {
        let data = response['data'];
        let updatedImg = localStorage.getItem('discountImg');
        this.eventImage = updatedImg ? JSON.parse(updatedImg) : data.imagePath;
        this.description = data.description.replace(/[#*]/g, '');
        let des = localStorage.getItem('description');
        if (this.description && !des) {
          this.btnText = 'Click to edit discount';
          localStorage.setItem('description', this.description);
          this.form.controls['description'].setValue(this.description);
        }
      },
      (error) => {
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        }
      }
    );
  }

  creatAd(val) {
    if (val == 1) {
      this.isCreate = true;
    } else if (val == 2) {
      this.isCreate = false;
    }
  }
  checkImage(usr) {
    if (usr) {
      let pathArray = usr.split('/');
      let protocol = pathArray[0];
      let host = pathArray[2];
      let url = protocol + '//' + host + '/';
      if (url == environment.basePath) {
        return usr;
      } else {
        return environment.basePath + usr;
      }
    }
  }
  openLink(type) {
    if (this.eventImage) {
      localStorage.setItem('discountImg', JSON.stringify(this.eventImage));
    }
    if (type == 1) {
      this.router.navigate(['/add-and-buy']);
    } else {
      localStorage.removeItem('discountImg');
      this.router.navigate(['/dashboard']);
    }
  }

  getSubscriptionPlan(data) {
    this.authenticationService
      .getCommonSubscriptionPlanById(this.userData?.subscriptionPlanType)
      .subscribe((res) => {
        this.SubscriptionPlan = res['data']?.caption;
      });
  }

  openInfo(content) {
    if (this.SubscriptionPlan !== 'Community Builder') {
      Swal.fire({
        title:
          'If you remove your discount, you will no longer be visible in the discount directory. Kingdom Partners will lose their profile badge and all associated benefits. Are you sure you want to remove it?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((res) => {
        if (res.isConfirmed) {
          this.deletePerpetualAdd(this.userData?._id);
        }
      });
    } else if (this.SubscriptionPlan == 'Community Builder') {
      Swal.fire({
        icon: 'error',
        title:
          'Community Builder subscribers are required to offer a discount. To remove the discount, you must cancel your paid subscription.',
      });
    }
  }

  selectImage(props, index) {
    this.selectedItem = index;
    this.item = props;
  }
  addimageForm() {
    this.eventImage = this.renderImage(this.item);

    this.authenticationService.SharingData.next(this.eventImage);
    return this.eventImage;
  }

  // gallery() {
  //   this.authenticationService.getGalleryImages().subscribe((res: any) => {
  //     this.galleryArr = res.items;
  //   },
  //     error => {
  //       if (error.error.message == "Unauthorized") {
  //         this.authenticationService.logout();
  //       }
  //     }
  //   )
  // }

  // photoGallery() {
  //   this.authenticationService.onphotoGallery().subscribe((res: any) => {
  //     console.log("Ress?????????????", res)
  //     this.galleryArr = res.data.images
  //   },
  //     error => {
  //       this.authenticationService.successMessage(error.error.message, 'error')
  //     }
  //   )
  // }

  galleryAndPhotoGallery() {
    forkJoin({
      gallery: this.authenticationService.getGalleryImages(),
      photoGallery: this.authenticationService.onphotoGallery(),
    }).subscribe(
      (results: any) => {
        const galleryImages = results.gallery.items || [];
        let photoGalleryImages = results.photoGallery.data.images || [];

        for (const image of galleryImages) {
          photoGalleryImages = [...photoGalleryImages, image.url];
        }

        this.galleryArr = photoGalleryImages;
      },
      (error) => {
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        } else {
          this.authenticationService.successMessage(
            error.error.message,
            'error'
          );
        }
      }
    );
  }

  photoGal() {
    this.router.navigate(["/photo-gallery"]);
  }

  renderImage(props: any) {
    if (props) return this.authenticationService.spilturl(props);
  }

  open(content) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  onclick() {
    console.log('hello');
  }

  goToSubscriptionPage() {
    this.router.navigate(['/mysubscration']);
  }
  deletePerpetualAdd(id: String) {
    let data = {
      id: id,
    };
    this.authenticationService
      .deletePerpetualAdd(data)
      .subscribe((res: any) => {
        if (res.code == 200) {
          this.form.controls['description'].setValue('');
          this.btnText = 'Click to add discount';
          localStorage.removeItem('description');
          this.getPerpetual();
          this.getUserProfile()
        }
      });
  }
}
